import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography, Link } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: '20px',
    height: '59px',
    textAlign: "center",
  }
}));

const Footer = props => {
  const { className, ...rest } = props;
  const year = new Date().getFullYear() ;
  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography variant="body1">
        <Link
          component="a"
          href="http://tinhocanhminh.com.vn"
          target="_blank"
        >
          Anh Minh Ltd
        </Link>
        <span> &copy;{year} (Cung cấp các giải pháp phần mềm )</span>
      </Typography>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
